/* ══════════════════════════════════════════════════════════════════
   Sleep Setup Widget — Standalone/Global Script  (v8)
   ══════════════════════════════════════════════════════════════════
   WHY THIS FILE EXISTS AS A SEPARATE STATIC ASSET (not inline in
   cart-products.liquid anymore):

   Browsers do NOT execute <script> tags that are inserted into the
   DOM via innerHTML / DOMParser / morph-style HTML replacement — only
   scripts present in the ORIGINAL server-rendered page parse normally.

   Loading this file ONCE, globally, via <script defer> in
   layout/theme.liquid solves this permanently.

   ══════════════════════════════════════════════════════════════════
   v8 CHANGES:

   1. productlist/mattress is GONE from this file. Category detection
      (does the cart contain a mattress / pillow / protector?) now
      reads the `_sw_category` line-item property that every
      add-to-cart flow (this widget, the Sleep Essentials section,
      and the PDP) stamps at add time. Zero API calls for detection.

   2. Gift data for free-gift.js is now extracted from the SAME
      `/apis/shopify/price/update` response this file already fetchesp
      for every real cart item (see "LIVE CART ITEM PRICE SYNC" near
      the bottom). Confirmed response shape:

        data.fullData.forgiftlist = [
          {
            gift_prod_id, gift_prod_name, qty_single, qty_queen,
            qty_king, price, length, breadth, ...
          },
          ...
        ]

      This is the exact same shape productlist/mattress's `.gifts`
      field used to have — so free-gift.js's matching/quantity logic
      barely changes, only the DATA SOURCE changes. Extracted gifts
      are cached in window.__swItemGiftData[itemKey] so free-gift.js
      never has to fetch anything itself.

   3. Free-gift line items (`_is_free_gift: 'true'`) are — and always
      were — excluded from price/update calls (see the `items` filter
      inside syncAllCartItemPrices below). Their price must always
      come straight from Shopify's own variant price (₹1), never from
      this API. That exclusion is now called out explicitly so nobody
      removes it by accident later.
   ══════════════════════════════════════════════════════════════════ */

/* 🛡️ SW CHECKOUT GATE HELPERS — yahan isliye hai kyunki ye file already
   globally load hoti hai (cart, PDP, collection — har page). PDP script
   aur sw-pincode-cart-recheck.js ise `window.__swValidateLineProps ?  ...`
   pattern se safely reference karte hain. */
(function () {
  if (window.__swCheckoutGateInit) return;
  window.__swCheckoutGateInit = true;

var REQUIRED_BY_CATEGORY = {
  // 🆕 _variant_id hataya — ye sirf ek redundant custom property thi
  // (Shopify ka apna item.variant_id hamesha correct hota hai chahe ye
  // property mojood ho ya na ho), isko required rakhna un carts ko
  // false-block kar raha tha jinka pricing/location/dimension data
  // poora tha lekin ye ek admin-visibility property missing thi.
  mattress:  ['_product_id','_length','_breadth','_thickness','_api_price','_sw_category'],
  pillow:    ['_product_id','_api_price','_sw_category'],
  protector: ['_product_id','_api_price','_sw_category'],
  sofa:      ['_product_id','_api_price','_sw_category']
};
  var BASE_REQUIRED = ['_product_id','_api_price','_sw_category'];

  function isGift(props) {
    return !!(props && (props['_is_free_gift'] === 'true' || props['_is_free_gift'] === true));
  }
  function requiredKeysFor(category) {
    return REQUIRED_BY_CATEGORY[category] || BASE_REQUIRED;
  }

  window.__swValidateLineProps = function (props) {
    props = props || {};
    if (isGift(props)) return { ok: true, missing: [] };
    var missing = requiredKeysFor(props['_sw_category']).filter(function (k) {
      var v = props[k];
      return v == null || String(v).trim() === '';
    });
    return { ok: missing.length === 0, missing: missing };
  };

  window.__swCartMissingRequiredItems = function (cart) {
    return (cart && cart.items || []).filter(function (it) {
      var p = it.properties || {};
      if (isGift(p)) return false;
      if (p['_not_available'] === 'true' || p['_props_incomplete'] === 'true') return true;
      return !window.__swValidateLineProps(p).ok;
    });
  };

  function showGateToast(msg) {
    if (typeof window.showToast === 'function') { window.showToast(msg); return; }
    var t = document.querySelector('.sw-gate-toast');
    if (t) t.remove();
    t = document.createElement('div');
    t.className = 'sw-gate-toast';
    t.style.cssText = 'position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:#cc0000;color:#fff;padding:12px 20px;border-radius:8px;z-index:99999;font-size:14px;font-weight:600;box-shadow:0 4px 12px rgba(0,0,0,.15);max-width:90vw;text-align:center;';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () {
      t.style.transition = 'opacity .3s'; t.style.opacity = '0';
      setTimeout(function () { t.remove(); }, 300);
    }, 4500);
  }
  window.__swShowGateToast = showGateToast;

  function blockReason(items) {
    var names = items.map(function (it) { return '"' + (it.product_title || it.title || 'Item') + '"'; });
    return names.length === 1
      ? names[0] + ' has incomplete data. Please remove it and add it again.'
      : names.join(', ') + ' have incomplete data. Please remove them and add again.';
  }

  window.__swAssertCartReadyForCheckout = function (cart) {
    var items = (cart && cart.items) || [];
    if (!items.length) { showGateToast('Your cart is empty.'); return Promise.resolve(false); }

    var missing = window.__swCartMissingRequiredItems(cart);
    if (missing.length) {
      console.error('🛑 Checkout blocked — incomplete line(s):', missing.map(function (it) {
        return { title: it.product_title || it.title, missing: window.__swValidateLineProps(it.properties || {}).missing };
      }));
      showGateToast(blockReason(missing));
      return Promise.resolve(false);
    }
    return Promise.resolve(true);
  };

  function isCheckoutTrigger(el) {
    if (!el || !el.closest) return false;
    return !!(
      el.closest('.gokwik-checkout, #gokwik-checkout, [data-gokwik-checkout]') ||
      el.closest('button[name="checkout"], input[name="checkout"]') ||
      el.closest('a[href="/checkout"], a[href$="/checkout"]')
    );
  }
  document.addEventListener('click', function (e) {
    if (!isCheckoutTrigger(e.target)) return;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return window.__swAssertCartReadyForCheckout(cart); })
      .then(function (ok) { if (!ok) { e.preventDefault(); e.stopImmediatePropagation(); } })
      .catch(function () {});
  }, true);

  console.log('🛡️ SW checkout gate helpers ready');
})();

(function () {
  'use strict';

  if (customElements.get('sleep-setup-widget')) return;

  var LIMIT = 4;

  var CURATED_PRODUCTS = {
    shieldProtector: { name: 'Shield Mattress Protector', categoryId: 'protector' },
    luxeProtector:   { name: 'Luxe Mattress Protector', categoryId: 'protector' },
    huggsPillow:     { name: 'Huggs Classic Compact Fibre Pillow (U)', categoryId: 'pillow' },
    zennPillow:      { name: 'Zenn Classic Ortho Foam Pillow (U)', categoryId: 'pillow' },
    sofabed:         { name: '1- seater sofa cum bed', categoryId: 'sofa' }
  };

  var shopifyImageMap = {};
  var shopifyHandleMap = {};
  var shopifyNormalizedHandleMap = {};
  var shopifyImageMapLoaded = false;
  var shopifyProductCache = {};

  function getApiId() {
    var storedId = localStorage.getItem('city_id');
    if (storedId) return storedId;

    var pincodeData = localStorage.getItem('pincodeData');
    if (pincodeData) {
      try {
        var d = JSON.parse(pincodeData);
        if (d && d.id) { localStorage.setItem('apiId', String(d.id)); return String(d.id); }
      } catch (e) {}
    }
    var stateData = localStorage.getItem('stateData');
    if (stateData) {
      try {
        var d = JSON.parse(stateData);
        if (d && d.id) { localStorage.setItem('apiId', String(d.id)); return String(d.id); }
      } catch (e) {}
    }
    return '259';
  }

  function normalizeTitle(str) {
    return String(str == null ? '' : str).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function fetchShopifyImages(callback) {
    if (shopifyImageMapLoaded) { callback(); return; }
    fetchAllShopifyProducts(function (products) {
      products.forEach(function (p) {
        shopifyImageMap[p.handle] = p.images && p.images.length > 0 ? p.images[0].src : '';
        var titleKey = (p.title || '').toLowerCase().trim();
        if (titleKey) shopifyHandleMap[titleKey] = p.handle;
        var normKey = normalizeTitle(p.title || '');
        if (normKey) shopifyNormalizedHandleMap[normKey] = p.handle;
        // v11 — cache the FULL product object (including variant SKUs,
        // prices, availability) per handle right here, from the same
        // /collections/all/products.json call we're already making for
        // images/handles. This is the exact same shape /products/{handle}.js
        // returns, so resolveVariantForSize() below can use it directly —
        // no separate per-item Shopify fetch needed at all.
        if (p.handle) shopifyProductCache[p.handle] = p;
      });
      shopifyImageMapLoaded = true;
      callback();
    });
  }

  function fetchAllShopifyProducts(callback) {
    var all = [];
    function loadPage(page) {
      fetch('/collections/all/products.json?limit=250&page=' + page)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.products) || [];
          all = all.concat(products);
          if (products.length === 250) {
            loadPage(page + 1);
          } else {
            callback(all);
          }
        })
        .catch(function () { callback(all); });
    }
    loadPage(1);
  }

  /* ALLCROSS API — single call, cached, split into pillow/protector/
     sofa buckets. This is the ONLY product-list API this file calls —
     purely to render curated cross-sell CARDS (name/price/image),
     never to detect cart membership. */
  var ALLCROSS_API_URL = 'https://sf-backend.mysleepwell.com/s1/shopify/products/allcross';
  var allCrossDataPromise = null;
  var allCrossSplit = null;

  function fetchAllCrossData() {
    if (allCrossSplit) return Promise.resolve(allCrossSplit);
    if (allCrossDataPromise) return allCrossDataPromise;

    allCrossDataPromise = fetch(ALLCROSS_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ city_id: Number(getApiId()) || 259 })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var categories = (data && data.categories) || [];
        var pillowAndProtectorCat = categories.find(function (c) {
          return (c.category_title || '').toLowerCase().indexOf('pillow') !== -1;
        });
        var sofaCat = categories.find(function (c) {
          return (c.category_title || '').toLowerCase().indexOf('sofa') !== -1;
        });

        var mixedProducts = (pillowAndProtectorCat && pillowAndProtectorCat.products) || [];
        var pillowList = mixedProducts.filter(function (p) {
          return (p.sscategory || '').toLowerCase().indexOf('pillow') !== -1;
        });
        var protectorList = mixedProducts.filter(function (p) {
          return (p.sscategory || '').toLowerCase().indexOf('protector') !== -1;
        });
        var sofaList = (sofaCat && sofaCat.products) || [];

        allCrossSplit = { pillow: pillowList, protector: protectorList, sofa: sofaList };
        console.log('Sleep setup: allcross API loaded — pillow:', pillowList.length, 'protector:', protectorList.length, 'sofa:', sofaList.length);
        return allCrossSplit;
      })
      .catch(function (e) {
        console.error('Sleep setup: allcross API failed:', e);
        allCrossSplit = { pillow: [], protector: [], sofa: [] };
        return allCrossSplit;
      });
    return allCrossDataPromise;
  }

  var categoryProductListCache = {};
  function fetchCategoryProductList(categoryId, callback) {
    if (categoryProductListCache[categoryId]) { callback(categoryProductListCache[categoryId]); return; }

    if (categoryId === 'pillow' || categoryId === 'protector' || categoryId === 'sofa') {
      fetchAllCrossData().then(function (split) {
        var list = split[categoryId] || [];
        console.log('Sleep setup: category "' + categoryId + '" loaded', list.length, 'product(s) from allcross API');
        categoryProductListCache[categoryId] = list;
        callback(list);
      });
      return;
    }

    // v8: mattress is never curated/displayed by this widget, so
    // there is no productlist/<category> fallback anymore.
    console.warn('Sleep setup: no product source configured for category "' + categoryId + '" — returning empty list.');
    categoryProductListCache[categoryId] = [];
    callback([]);
  }
  window.__swFetchCategoryProductList = fetchCategoryProductList;

  function getShopifyHandle(product) {
    var rawTitle = product.listing_title || product.zoneTitle || '';
    var titleKey = rawTitle.toLowerCase().trim();

    if (shopifyHandleMap[titleKey]) {
      return shopifyHandleMap[titleKey];
    }

    var normKey = normalizeTitle(rawTitle);
    if (normKey && shopifyNormalizedHandleMap[normKey]) {
      return shopifyNormalizedHandleMap[normKey];
    }

    if (normKey) {
      var normTokens = normKey.split(' ').filter(Boolean);
      var candidateHandle = null;
      Object.keys(shopifyNormalizedHandleMap).some(function (key) {
        if (key.indexOf(normKey) !== -1 || normKey.indexOf(key) !== -1) {
          candidateHandle = shopifyNormalizedHandleMap[key];
          return true;
        }
        var keyTokens = key.split(' ').filter(Boolean);
        var allTokensPresent = normTokens.length > 0 && normTokens.every(function (tok) {
          return keyTokens.indexOf(tok) !== -1;
        });
        if (allTokensPresent) {
          candidateHandle = shopifyNormalizedHandleMap[key];
          return true;
        }
        return false;
      });
      if (candidateHandle) return candidateHandle;
    }

    if (product.shopify_handle) {
      console.warn('Sleep setup: falling back to API-provided shopify_handle for', rawTitle, '->', product.shopify_handle);
      return product.shopify_handle;
    }

    var guessedHandle = rawTitle.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    console.warn('Sleep setup: could not match "' + rawTitle + '" to any Shopify product - guessing handle "' + guessedHandle + '". This item will likely fail to resolve.');
    return guessedHandle;
  }

  function getShopifyImage(product, handleSlug) {
    if (shopifyImageMap[handleSlug]) return shopifyImageMap[handleSlug];
    if (product.shopify_handle && shopifyImageMap[product.shopify_handle]) return shopifyImageMap[product.shopify_handle];
    if (product.listing_image) return 'https://mysleepwell-api.mysleepwell.com/' + product.listing_image;
    return '';
  }

  function escAttr(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function formatMoney(amount) {
    return '₹' + (Math.round(amount) || 0);
  }

  function sanitizeTitle(str) {
    var text = String(str == null ? '' : str)
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return escAttr(text);
  }

  function findProductByName(productlist, targetName) {
    var target = normalizeTitle(targetName);
    var targetTokens = target.split(' ').filter(Boolean);

    var exact = productlist.find(function (p) {
      return normalizeTitle(p.zoneTitle || p.listing_title || '') === target;
    });
    if (exact) return exact;

    var substr = productlist.find(function (p) {
      var t = normalizeTitle(p.zoneTitle || p.listing_title || '');
      return t.indexOf(target) !== -1 || target.indexOf(t) !== -1;
    });
    if (substr) return substr;

    var tokenMatch = productlist.find(function (p) {
      var t = normalizeTitle(p.zoneTitle || p.listing_title || '');
      var tTokens = t.split(' ').filter(Boolean);
      return targetTokens.length > 0 && targetTokens.every(function (tok) {
        return tTokens.indexOf(tok) !== -1;
      });
    });
    if (tokenMatch) return tokenMatch;

    return null;
  }

  function findClosestVariant(variantsList, targetSize, excludeVariantIds) {
    excludeVariantIds = excludeVariantIds || {};

    var withSize = (variantsList || [])
      .map(function (v) {
        var l = parseFloat(v.length);
        var b = parseFloat(v.breadth);
        if (!l || !b) return null;
        var dims = [l, b].sort(function (x, y) { return y - x; });
        return { v: v, area: dims[0] * dims[1] };
      })
      .filter(Boolean);
    if (!withSize.length) return null;

    var unused = withSize.filter(function (x) { return !excludeVariantIds[x.v.variant_id]; });
    var candidates = unused.length ? unused : withSize;

    var exact = candidates.find(function (x) {
      var l = parseFloat(x.v.length), b = parseFloat(x.v.breadth);
      var dims = [l, b].sort(function (p, q) { return q - p; });
      return (dims[0] + 'X' + dims[1]) === targetSize.label;
    });
    if (exact) return exact.v;

    candidates.sort(function (a, b) {
      return Math.abs(a.area - targetSize.area) - Math.abs(b.area - targetSize.area);
    });
    return candidates[0].v;
  }

  function parseSizeFromString(str) {
    if (!str) return null;
    var m = String(str).match(/(\d+(?:\.\d+)?)\s*[xX\u00d7]\s*(\d+(?:\.\d+)?)/);
    if (!m) return null;
    var a = parseFloat(m[1]);
    var b = parseFloat(m[2]);
    if (!a || !b) return null;
    var dims = [a, b].sort(function (x, y) { return y - x; });
    return { label: dims[0] + 'X' + dims[1], area: dims[0] * dims[1] };
  }

  // v11 — Shopify variant SKUs in this store follow a deterministic
  // pattern: {productCode}{length}X{breadth}X{height}-{internalId}
  // e.g. "SMM72X36X0-264384" -> 72X36, "HCM24X16X0-264248" -> 24X16.
  // This is a far more reliable size signal than parsing the
  // human-entered variant TITLE text (which can be phrased many ways
  // — "Single / #000 / 72X36", "72 x 36", etc.) — the SKU is
  // machine-generated and consistent. This is real Shopify data (the
  // SKU), just read more precisely than free-text title parsing.
  function parseSizeFromSku(sku) {
    if (!sku) return null;
    var m = String(sku).match(/(\d+(?:\.\d+)?)X(\d+(?:\.\d+)?)X/i);
    if (!m) return null;
    var a = parseFloat(m[1]);
    var b = parseFloat(m[2]);
    if (!a || !b) return null;
    var dims = [a, b].sort(function (x, y) { return y - x; });
    return { label: dims[0] + 'X' + dims[1], area: dims[0] * dims[1] };
  }

  // v12 — same SKU pattern, also capturing the THIRD number (thickness/
  // height): {code}{length}X{breadth}X{thickness}-{id}, e.g.
  // "DCM78X30X5-263190" -> length 78, breadth 30, thickness 5. Used
  // wherever we need all three real dimensions (e.g. the price/update
  // request payload), not just the length×breadth label.
  function parseFullDimsFromSku(sku) {
    if (!sku) return null;
    var m = String(sku).match(/(\d+(?:\.\d+)?)X(\d+(?:\.\d+)?)X(\d+(?:\.\d+)?)-/i);
    if (!m) return null;
    var length = parseFloat(m[1]);
    var breadth = parseFloat(m[2]);
    var thickness = parseFloat(m[3]);
    if (!length || !breadth) return null;
    return { length: length, breadth: breadth, thickness: thickness };
  }

  // v13 — BUGFIX (regression from v12): v12 made SKU/variant_title take
  // priority over properties, reasoning that SKU always describes the
  // REAL Shopify variant. That's true for a standard-size add — but for
  // CUSTOM SIZE mattresses, Shopify has no real variant for the chosen
  // dimensions at all. The PDP add-to-cart flow explicitly falls back to
  // reusing a nearby STANDARD variant as a cart placeholder in that case
  // (see the PDP script's own "using closest thickness-matched variant
  // as cart placeholder" warning) — so a custom-size line's SKU and
  // variant_title describe a DIFFERENT, standard size, not the actual
  // custom size the shopper chose. The only place the real custom
  // dimensions live is the `_length`/`_breadth` properties (and the
  // human-readable `Custom Size` property, which is the definitive
  // signal that this line's SKU cannot be trusted for sizing).
  //
  // So: if `Custom Size` is present, properties are read FIRST (they're
  // the only correct source here); SKU/variant_title are only used for
  // everything else, exactly as v12 set up.
  function getMattressSizeFromCartItem(item) {
    var isCustomSize = !!(item.properties && item.properties['Custom Size']);

    if (isCustomSize) {
      var customLength = item.properties && parseFloat(item.properties['_length']);
      var customBreadth = item.properties && parseFloat(item.properties['_breadth']);
      if (customLength && customBreadth) {
        var customDims = [customLength, customBreadth].sort(function (x, y) { return y - x; });
        return { label: customDims[0] + 'X' + customDims[1], area: customDims[0] * customDims[1] };
      }
      console.warn('Sleep setup: item has a "Custom Size" property but no usable _length/_breadth to read from — falling back to SKU/variant_title, which will be WRONG for a custom-size line (they describe the fallback placeholder variant, not the actual custom size).');
    }

    var fromSku = parseSizeFromSku(item.sku);
    if (fromSku) return fromSku;

    var fromTitle = item.variant_title && parseSizeFromString(item.variant_title);
    if (fromTitle) return fromTitle;

    var opts = item.options_with_values || [];
    for (var i = 0; i < opts.length; i++) {
      var found = parseSizeFromString(opts[i].value);
      if (found) return found;
    }

    var propLength = item.properties && parseFloat(item.properties['_length']);
    var propBreadth = item.properties && parseFloat(item.properties['_breadth']);
    if (propLength && propBreadth) {
      console.warn('Sleep setup: falling back to (possibly stale) _length/_breadth PROPERTIES for "' + (item.product_title || item.title) + '" — could not determine size from SKU or variant title/options. If this product\'s size is later wrong, check whatever add-to-cart flow stamped these properties.');
      var dims = [propLength, propBreadth].sort(function (x, y) { return y - x; });
      return { label: dims[0] + 'X' + dims[1], area: dims[0] * dims[1] };
    }

    return null;
  }

  /* v8 — replaces getTargetProtectorSizes(cart, mattressHandleSet).
     mattressItems is already the exact list of cart items whose
     `_sw_category` === 'mattress', read straight from /cart.js. */
  function getTargetProtectorSizesFromItems(mattressItems) {
    var sizesByLabel = {};
    mattressItems.forEach(function (item) {
      var size = getMattressSizeFromCartItem(item);
      if (!size) return;
      if (!sizesByLabel[size.label]) sizesByLabel[size.label] = size;
    });
    var sizes = Object.keys(sizesByLabel).map(function (k) { return sizesByLabel[k]; });
    sizes.sort(function (a, b) { return b.area - a.area; });
    return sizes.slice(0, 2);
  }

  /* v8 — category membership comes straight from each cart item's own
     `_sw_category` property. No productlist/mattress (or any other
     category) API call happens here anymore. */
  function determineDisplayProducts(callback) {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var cartHandles = items.map(function (it) { return it.handle; });

        function itemsInCategory(cat) {
          return items.filter(function (it) {
            return it.properties && it.properties['_sw_category'] === cat;
          });
        }

        var mattressItems = itemsInCategory('mattress');
        var hasMattress = mattressItems.length > 0;
        var hasPillow = itemsInCategory('pillow').length > 0;
        var hasProtector = itemsInCategory('protector').length > 0;

        console.log('Sleep setup: cartHandles=', cartHandles, 'hasMattress=', hasMattress, 'hasPillow=', hasPillow, 'hasProtector=', hasProtector);

        var curated = [];
        if (hasMattress) {
          var protectorSizes = getTargetProtectorSizesFromItems(mattressItems);
          var protectorEntries = protectorSizes.length
            ? protectorSizes.map(function (sz) {
                return {
                  name: 'Mattress Protector',
                  categoryId: CURATED_PRODUCTS.shieldProtector.categoryId,
                  targetSize: sz,
                  sizeMatchOnly: true
                };
              })
            : [CURATED_PRODUCTS.shieldProtector];

          curated = protectorEntries.concat([
            CURATED_PRODUCTS.huggsPillow,
            CURATED_PRODUCTS.zennPillow,
            CURATED_PRODUCTS.sofabed
          ]);
        } else if (hasPillow && hasProtector) {
          curated = [CURATED_PRODUCTS.sofabed];
        } else if (hasPillow) {
          curated = [CURATED_PRODUCTS.shieldProtector, CURATED_PRODUCTS.luxeProtector];
        } else if (hasProtector) {
          curated = [CURATED_PRODUCTS.huggsPillow, CURATED_PRODUCTS.zennPillow];
        }

        callback(curated, cartHandles, cart.item_count || 0);
      })
      .catch(function () {
        callback([], [], 0);
      });
  }

  function createProductCard(product, handleSlug, opts) {
    opts = opts || {};

    var shownPrice, comparePrice, displayDiscount, isUpTo, discountLabel;

    if (opts.priceOverride) {
      shownPrice = parseFloat(opts.priceOverride.salePrice) || 0;
      comparePrice = parseFloat(opts.priceOverride.comparePrice) || 0;
      displayDiscount = parseFloat(opts.priceOverride.discount) || 0;
      isUpTo = false;
      discountLabel = displayDiscount > 0 ? ('FLAT ' + displayDiscount + '% OFF') : '';
    } else {
      var originalPrice = parseFloat(product.unitPrice) || 0;
      var discountedPrice = parseFloat(product.price) || 0;
      var vdiscount = parseFloat(product.vdiscount) || 0;
      var discountpercent = parseFloat(product.discountpercent) || 0;
      displayDiscount = 0; isUpTo = false;
      if (vdiscount > 0) { displayDiscount = vdiscount; isUpTo = true; }
      else if (discountpercent > 0) { displayDiscount = discountpercent; }
      discountLabel = displayDiscount > 0 ? ((isUpTo ? 'UP TO ' : 'FLAT ') + displayDiscount + '% OFF') : '';

      shownPrice = displayDiscount > 0 && discountedPrice < originalPrice ? discountedPrice : originalPrice;
      comparePrice = displayDiscount > 0 && discountedPrice < originalPrice ? originalPrice : 0;
    }

    var imageUrl = getShopifyImage(product, handleSlug);
    var productUrl = '/products/' + handleSlug + '?api_pid=' + product.id;
    var title = sanitizeTitle(product.zoneTitle || product.listing_title || '');

    var priceHtml = '<span class="ss-price-now">' + formatMoney(shownPrice) + '</span>';
    if (comparePrice > shownPrice) {
      priceHtml +=
        '<span class="ss-price-was">' + formatMoney(comparePrice) + '</span>' +
        '<span class="ss-discount">' + discountLabel + '</span>';
    }

    var cardFeatures = ((window.SW_SS_PVARIANTS || {})[handleSlug] || []).filter(Boolean);
    var featuresHtml = cardFeatures.length
      ? '<span class="ss-card-tag">' + cardFeatures.map(sanitizeTitle).join(' . ') + '</span>'
      : '';

    var sizeChipHtml = opts.sizeLabel
      ? '<span class="ss-card-chip">Size: ' + escAttr(opts.sizeLabel) + '</span>'
      : '';

    var wyltList = ((window.SW_SS_WYLT || {})[handleSlug] || []).filter(function (w) { return w && w.text; });
    var wyltHtml = '';
    if (wyltList.length) {
      wyltHtml = '<div class="ss-card-wylt-list">' +
        wyltList.map(function (w) {
          var icon = w.icon
            ? '<span class="ss-card-wylt-icon"><img src="' + escAttr(w.icon) + '" alt="" loading="lazy"></span>'
            : '<span class="ss-card-wylt-icon ss-card-wylt-icon--dot"></span>';
          return '<div class="ss-card-wylt-item">' + icon + '<span class="ss-card-wylt-text">' + sanitizeTitle(w.text) + '</span></div>';
        }).join('') +
        '</div>';
    }

    var fallbackImg = 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22300%22 height=%22300%22 viewBox=%220 0 300 300%22%3E%3Crect fill=%22%23f5f5f5%22 width=%22300%22 height=%22300%22/%3E%3Ctext x=%2250%25%22 y=%2250%25%22 text-anchor=%22middle%22 dy=%22.3em%22 fill=%22%23999%22 font-family=%22sans-serif%22 font-size=%2216%22%3ENo Image%3C/text%3E%3C/svg%3E';

    var card = document.createElement('div');
    card.className = 'ss-product-card';
    card.dataset.productId = product.id;
    card.dataset.handle = handleSlug;
    // v8 — stamped on the DOM node so handleClick() can read it and
    // forward it as the `_sw_category` line-item property.
    card.dataset.categoryId = opts.categoryId || '';
    if (opts.sizeLabel) card.dataset.sizeLabel = opts.sizeLabel;
   card.dataset.length    = opts.length    || parseFloat(product.length)    || 72;
    card.dataset.breadth   = opts.breadth   || parseFloat(product.breadth)   || 30;
    var isPillowOrProtector = (opts.categoryId === 'pillow' || opts.categoryId === 'protector');
    if (opts.thickness != null) {
      card.dataset.thickness = opts.thickness;
    } else {
      var parsedThk = parseFloat(product.thickness);
      card.dataset.thickness = !isNaN(parsedThk) ? parsedThk : (isPillowOrProtector ? 0 : 0);
    }
    card.dataset.lengthMm    = opts.lengthMm    != null ? opts.lengthMm    : (product.lengthMm    != null ? product.lengthMm    : '');
card.dataset.breadthMm   = opts.breadthMm   != null ? opts.breadthMm   : (product.breadthMm   != null ? product.breadthMm   : '');
card.dataset.thicknessMm = opts.thicknessMm != null ? opts.thicknessMm : (product.thicknessMm != null ? product.thicknessMm : '');
    card.innerHTML =
      '<div class="ss-card-top">' +
        '<div class="ss-card-img-col">' +
          '<a href="' + productUrl + '" class="ss-card-img-wrap">' +
            '<img src="' + (imageUrl || fallbackImg) + '" alt="' + title + '" loading="lazy" onerror="this.src=\'' + fallbackImg + '\'">' +
          '</a>' +
          sizeChipHtml +
        '</div>' +
        '<div class="ss-card-body">' +
          '<a href="' + productUrl + '" class="ss-card-title-link"><h3>' + title + '</h3></a>' +
          featuresHtml +
          '<div class="ss-card-jm-slot"></div>' +
          wyltHtml +
          '<div class="ss-price-row">' + priceHtml + '</div>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="sw-ss-atc" ' +
        'data-price="' + shownPrice + '" ' +
        'data-compare="' + comparePrice + '" ' +
        'data-discount="' + displayDiscount + '"' +
        (opts.variantId ? ' data-variant-id="' + opts.variantId + '"' : '') +
        '>Add To Cart</button>';

    return card;
  }

  function injectJudgeMe(card, handle) {
    if (!card || !handle) return;
    var slot = card.querySelector('.ss-card-jm-slot');
    if (!slot) return;
    var holder = document.querySelector('.sw-ss-jm-holder[data-handle="' + handle + '"]');
    if (holder && holder.firstElementChild) {
      slot.innerHTML = '';
      slot.appendChild(holder.firstElementChild.cloneNode(true));
    }
  }

  var jdgmDebugLogged = false;
  function refreshJudgeMeBadges() {
    try {
      if (!window.jdgm) return;
      if (!jdgmDebugLogged) {
        jdgmDebugLogged = true;
        console.log('sleep-setup: window.jdgm keys ->', Object.keys(window.jdgm));
      }
      if (typeof window.jdgm.batchRenderBadges === 'function') window.jdgm.batchRenderBadges();
      if (window.jdgm.badge && typeof window.jdgm.badge.init === 'function') window.jdgm.badge.init();
      if (typeof window.jdgm.renderBadges === 'function') window.jdgm.renderBadges();
      if (typeof window.jdgm.init === 'function') window.jdgm.init();
    } catch (e) {
      console.warn('Judge.me badge refresh failed:', e);
    }
  }
  function refreshJudgeMeBadgesWithRetries() {
    [0, 400, 1000, 2000, 3500].forEach(function (delay) {
      setTimeout(refreshJudgeMeBadges, delay);
    });
  }
  window.addEventListener('load', function () { refreshJudgeMeBadgesWithRetries(); });

  function fetchShopifyProduct(handle, callback) {
    if (shopifyProductCache[handle]) { callback(shopifyProductCache[handle]); return; }
    fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error('fetch failed'); return r.json(); })
      .then(function (p) { shopifyProductCache[handle] = p; callback(p); })
      .catch(function () { callback(null); });
  }

  function computeDisplayTotal(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      var apiPrice = item.properties && item.properties['_api_price'];
      var unitPrice;
      if (apiPrice !== undefined && apiPrice !== null && apiPrice !== '') {
        unitPrice = parseFloat(apiPrice) || 0;
      } else {
        unitPrice = (item.final_price || item.price || 0) / 100;
      }
      total += unitPrice * (item.quantity || 1);
    });
    return total;
  }

  function updateCartTotalsUI(cart) {
    if (window.__swDrawerMorphInFlight) {
      setTimeout(function () { updateCartTotalsUI(cart); }, 150);
      return;
    }
    var totalRupees = computeDisplayTotal(cart);
    var formatted = '₹ ' + totalRupees.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' INR';
    var matched = document.querySelectorAll('[data-cart-subtotal], .cart-totals__total-value');

    matched.forEach(function (el) {
      el.textContent = formatted;
      if (el.hasAttribute && el.hasAttribute('value')) {
        el.setAttribute('value', formatted);
      }
    });
  }

  // v11 — REWRITTEN. Price-based variant matching has been removed
  // entirely: price/discount/size are decided by the sf-backend API,
  // never by comparing against Shopify. What we DO need from Shopify
  // is the real variant ID (and image, and metaobject content) for a
  // given product+size — resolved here via the variant's own SKU,
  // which deterministically encodes size (see parseSizeFromSku
  // above), falling back to title-text parsing only if a SKU doesn't
  // match the expected pattern.
  //
  // `targetSize` is optional. When provided (the normal case — every
  // curated card now pre-resolves by size at render time), it's used
  // to pick the correct variant among several. When omitted, this
  // simply returns the product's only/first available variant — used
  // only as the last-resort fallback in handleClick() for the rare
  // case a product had no usable dimensions at render time.
  function resolveVariantByIdentity(handle, targetSize, callback) {
    fetchShopifyProduct(handle, function (product) {
      if (!product || !product.variants || !product.variants.length) { callback(null); return; }
      var variants = product.variants;
      var available = variants.filter(function (v) { return v.available; });
      var pool = available.length ? available : variants;

      // Single-variant product (most pillows, sofas) — nothing to
      // match, this IS the product's only variant.
      if (pool.length === 1) { callback(pool[0]); return; }

      if (!targetSize) { callback(pool[0]); return; }

      // Primary: match by SKU-encoded size (deterministic, real
      // Shopify data).
      var skuMatch = pool.find(function (v) {
        var s = parseSizeFromSku(v.sku);
        return s && s.label === targetSize.label;
      });
      if (skuMatch) { callback(skuMatch); return; }

      // Fallback: match by parsing the variant title text (less
      // reliable, kept only for variants whose SKU doesn't follow the
      // expected pattern).
      var titleMatch = pool.find(function (v) {
        var s = parseSizeFromString(v.title);
        return s && s.label === targetSize.label;
      });
      if (titleMatch) { callback(titleMatch); return; }

      // Last resort: closest by area, preferring whichever of
      // SKU/title actually parsed to something.
      var withParsedSize = pool
        .map(function (v) { return { v: v, size: parseSizeFromSku(v.sku) || parseSizeFromString(v.title) }; })
        .filter(function (x) { return x.size; });
      if (withParsedSize.length) {
        withParsedSize.sort(function (a, b) {
          return Math.abs(a.size.area - targetSize.area) - Math.abs(b.size.area - targetSize.area);
        });
        callback(withParsedSize[0].v);
        return;
      }

      console.warn('Sleep setup: could not match any variant of "' + handle + '" to size ' + targetSize.label + ' by SKU or title — using first available variant as a last resort. Check this product\'s SKU pattern.');
      callback(pool[0]);
    });
  }

  // Thin wrappers kept so call sites read clearly at each use.
  function resolveVariantForSize(handle, targetSize, callback) {
    resolveVariantByIdentity(handle, targetSize, callback);
  }

  function resolveVariantForCard(handle, callback) {
    resolveVariantByIdentity(handle, null, callback);
  }

 function dispatchRealCartAddEvent(cart, sourceHandle) {
    var dialog = document.querySelector('cart-drawer-component dialog');
    var wasOpen = !!(dialog && dialog.open);

    if (!wasOpen) {
      var CartAddEvent = window.__sleepSetupCartAddEvent;
      if (CartAddEvent) {
        try {
          var evt = new CartAddEvent({ resource: cart }, sourceHandle, {});
          document.dispatchEvent(evt);
        } catch (e) {
          console.error('Sleep setup: CartAddEvent dispatch failed', e);
        }
      }
    }

    if (window.swRefreshCartDrawer) {
      window.swRefreshCartDrawer({ delay: wasOpen ? 150 : 500 });
    } else {
      tryRefreshNativeCart();
    }
  }

  function getCartDrawerSectionWrapper() {
    var widget = document.getElementById('sw-sleep-setup');
    if (!widget) return null;
    return widget.closest('[id^="shopify-section-"]');
  }

  var _headerRefreshInFlight = null;
  var _headerRefreshDebounceTimer = null;

  function doHeaderRefresh() {
    if (window.refreshCart) {
      // v11 — BUGFIX: this branch (delegating to GoKwik's own
      // window.refreshCart) previously had NO in-flight de-dup at
      // all, unlike the fallback path below. Confirmed via Network
      // tab Initiator stack: sleepwellRefreshHeaderSection() calling
      // window.refreshCart() re-enters GoKwik's own kp-merchant-v2.js
      // fetch cascade, which itself re-enters OUR fetch patch and
      // Shopify's own shop_events_listener — every UNDEBOUNCED call
      // here multiplied into several extra /cart.js round trips per
      // single user action, a direct contributor to the reported
      // flickering. Reuses the exact same _headerRefreshInFlight
      // promise-dedup pattern the fallback path already had.
      if (_headerRefreshInFlight) return _headerRefreshInFlight;
      _headerRefreshInFlight = Promise.resolve(window.refreshCart()).then(function (result) {
        _headerRefreshInFlight = null;
        return result;
      }).catch(function (e) {
        _headerRefreshInFlight = null;
        console.warn('sleepwellRefreshHeaderSection: window.refreshCart() failed', e);
      });
      return _headerRefreshInFlight;
    }
    if (_headerRefreshInFlight) return _headerRefreshInFlight;
    _headerRefreshInFlight = fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var expectedCount = cart.item_count || 0;
        document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-count, .cart-bubble__text-count')
          .forEach(function (el) { el.textContent = expectedCount; });
        document.querySelectorAll('.cart-bubble').forEach(function (el) {
          el.classList.toggle('visually-hidden', expectedCount === 0);
        });
      })
      .catch(function (e) {
        console.warn('sleepwellRefreshHeaderSection failed', e);
      })
      .then(function () {
        _headerRefreshInFlight = null;
      });
    return _headerRefreshInFlight;
  }

  // v11 — ALSO debounce the trigger itself: previously called directly,
  // undebounced, from two separate event listeners ('sleep-setup:cart-
  // changed' and 'cart:refresh') that often both fire from the SAME
  // single cart mutation — meaning this ran twice per action even
  // before considering the in-flight dedup above. Now multiple calls
  // within a short window collapse into one, same pattern as
  // debouncedWidgetRender().
  window.sleepwellRefreshHeaderSection = function () {
    clearTimeout(_headerRefreshDebounceTimer);
    return new Promise(function (resolve) {
      _headerRefreshDebounceTimer = setTimeout(function () {
        doHeaderRefresh().then(resolve, resolve);
      }, 120);
    });
  };

  function tryRefreshNativeCart() {
    ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build', 'cart-update', 'cart:update']
      .forEach(function (name) {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: {} }));
      });
  }
  window.tryRefreshNativeCart = tryRefreshNativeCart;

  var activeInstances = [];

  var CART_ADD_RE = /\/cart\/add(\.js)?(\?|$)/;

  var DUPLICATE_ADD_WINDOW_MS = 2000;
  var pendingAddRequests = {};

  function fingerprintAddBody(parsedBody) {
    try {
      var props = parsedBody.properties || {};
      var sortedKeys = Object.keys(props).sort();
      var normalizedProps = {};
      sortedKeys.forEach(function (k) { normalizedProps[k] = props[k]; });
      return JSON.stringify({
        id: parsedBody.id,
        quantity: parsedBody.quantity || 1,
        properties: normalizedProps
      });
    } catch (e) {
      return null;
    }
  }

  function dedupedCartAdd(parsedBody, doAdd) {
    var fp = fingerprintAddBody(parsedBody);
    if (!fp) return doAdd();

    var pending = pendingAddRequests[fp];
    var now = Date.now();
    if (pending && (now - pending.ts) < DUPLICATE_ADD_WINDOW_MS) {
      console.warn('🛑 Duplicate /cart/add.js request collapsed (same variant+properties within ' + DUPLICATE_ADD_WINDOW_MS + 'ms) — returning the in-flight request instead of adding again.');
      return pending.promise;
    }

    var promise = doAdd().then(function (res) {
      delete pendingAddRequests[fp];
      return res;
    }).catch(function (err) {
      delete pendingAddRequests[fp];
      throw err;
    });
    pendingAddRequests[fp] = { promise: promise, ts: now };
    return promise;
  }

  function mergeAwareCartAdd(input, init, origFetch) {
    var parsedBody = null;
    try {
      parsedBody = init && init.body ? JSON.parse(init.body) : null;
    } catch (e) {
      parsedBody = null;
    }

    if (!parsedBody || parsedBody.id == null) {
      return origFetch(input, init);
    }

    return dedupedCartAdd(parsedBody, function () {
      return doMergeAwareCartAdd(input, init, origFetch, parsedBody);
    });
  }

  function doMergeAwareCartAdd(input, init, origFetch, parsedBody) {
    var variantId = parsedBody.id;
    var addQty = parseInt(parsedBody.quantity, 10) || 1;
    var properties = parsedBody.properties || {};

    return origFetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var lineIdx = -1;
        // v9 — BUGFIX: previously this matched ONLY on variant_id,
        // which meant adding "the same product" at a DIFFERENT pincode
        // silently found the OLD line (added at a previous pincode) and
        // overwrote its location/price properties instead of creating
        // a distinct line for the new pincode — the old pincode's data
        // just vanished, quantity kept climbing on one line, and it
        // looked like "nothing is updating" even though a merge WAS
        // happening (just the wrong kind). Now the location
        // (`_city_id`) must ALSO match before this counts as a genuine
        // duplicate worth merging — adding at a new pincode always
        // creates a fresh, distinct line (exactly like Shopify's native
        // behavior for differing line-item properties). Any resulting
        // duplicates (same product, different historical pincodes) are
        // consolidated separately whenever the pincode actually changes
        // — see sw-pincode-cart-recheck.js.
        var newCityId = String(properties['_city_id'] || '');
        for (var i = 0; i < items.length; i++) {
          var isGiftLine = items[i].properties && items[i].properties['_is_free_gift'] === 'true';
          var sameVariant = String(items[i].variant_id) === String(variantId);
          var existingCityId = String((items[i].properties && items[i].properties['_city_id']) || '');
          var sameLocation = existingCityId === newCityId;
          if (!isGiftLine && sameVariant && sameLocation) { lineIdx = i; break; }
        }

        if (lineIdx === -1) {
          return origFetch(input, init);
        }

        // 🆕 FIX: pehle ye existing line ki properties ko is call ki
        // properties se COMPLETELY REPLACE kar deta tha. Agar ye call
        // Sleep Setup jaise chhote property-set (bina _city_id/_variant_id)
        // se aayi, to poori-complete line overwrite ho jaati thi.
        var existingProps = items[lineIdx].properties || {};
        var incomingComplete = !!(properties['_city_id'] && properties['_product_id']);
        var existingComplete = !!(existingProps['_city_id'] && existingProps['_product_id']);
        var mergedProps = (existingComplete && !incomingComplete)
          ? Object.assign({}, properties, existingProps)   // purana poora hai → preserve
          : Object.assign({}, existingProps, properties);  // default: naya overrides missing fields

        var existingQty = parseInt(items[lineIdx].quantity, 10) || 0;
        var newQty = existingQty + addQty;
        return origFetch('/cart/change.js', {
          method: 'POST',
          cache: 'no-store',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: lineIdx + 1, quantity: newQty, properties: mergedProps })
        });
      })
      .catch(function () {
        return origFetch(input, init);
      });
  }

  if (!window.__sleepSetupFetchPatched) {
    window.__sleepSetupFetchPatched = true;
    var _origFetch = window.fetch.bind(window);
    var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    var CART_QTY_ONLY_RE = /\/cart\/change(\.js)?(\?|$)/;

    window.fetch = function (input, init) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) {}
      var isCartMutation = CART_MUTATION_RE.test(url);
      var isSilent = !!(init && init.headers && init.headers['X-SW-Silent-Cart-Sync']);
      var isCartAdd = CART_ADD_RE.test(url) && init && init.method && init.method.toUpperCase() === 'POST' && !isSilent;

      var request = isCartAdd
        ? mergeAwareCartAdd(input, init, _origFetch)
        : _origFetch(input, init);

     return request.then(function (response) {
    if (isCartMutation && response && response.ok && !isSilent) {
      var extraDelay = CART_QTY_ONLY_RE.test(url) ? 300 : 50;
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('sleep-setup:cart-changed'));
      }, extraDelay);
    }
    return response;
  });
};

    function mirrorXhrError(targetXhr) {
      try {
        Object.defineProperty(targetXhr, 'readyState', { value: 4, configurable: true });
        Object.defineProperty(targetXhr, 'status', { value: 0, configurable: true });
      } catch (e) {}
      try { targetXhr.dispatchEvent(new Event('readystatechange')); } catch (e) {}
      try { targetXhr.dispatchEvent(new Event('error')); } catch (e) {}
      try { targetXhr.dispatchEvent(new Event('loadend')); } catch (e) {}
    }

    function mirrorResponseOntoXhr(targetXhr, source) {
      function apply(status, statusText, responseText) {
        try {
          Object.defineProperty(targetXhr, 'readyState', { value: 4, configurable: true });
          Object.defineProperty(targetXhr, 'status', { value: status, configurable: true });
          Object.defineProperty(targetXhr, 'statusText', { value: statusText || '', configurable: true });
          Object.defineProperty(targetXhr, 'responseText', { value: responseText || '', configurable: true });
          Object.defineProperty(targetXhr, 'response', { value: responseText || '', configurable: true });
        } catch (e) {}
        try { targetXhr.dispatchEvent(new Event('readystatechange')); } catch (e) {}
        try { targetXhr.dispatchEvent(new Event('load')); } catch (e) {}
        try { targetXhr.dispatchEvent(new Event('loadend')); } catch (e) {}
      }

      if (source && typeof source.clone === 'function') {
        source.clone().text().then(function (text) {
          apply(source.status, source.statusText, text);
        }).catch(function () { mirrorXhrError(targetXhr); });
      } else if (source && typeof source.status === 'number') {
        apply(source.status, source.statusText, source.responseText);
      } else {
        mirrorXhrError(targetXhr);
      }
    }

    var _origXhrOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__sleepSetupIsCartMutation = CART_MUTATION_RE.test(String(url || ''));
      this.__sleepSetupIsCartAdd = CART_ADD_RE.test(String(url || '')) && String(method || '').toUpperCase() === 'POST';
      return _origXhrOpen.apply(this, arguments);
    };

    var _origXhrSetHeader = XMLHttpRequest.prototype.setRequestHeader;
    XMLHttpRequest.prototype.setRequestHeader = function (name, value) {
      if (this.__sleepSetupIsCartAdd) {
        this.__sleepSetupHeaders = this.__sleepSetupHeaders || {};
        this.__sleepSetupHeaders[name] = value;
      }
      return _origXhrSetHeader.apply(this, arguments);
    };

    var _origXhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function (body) {
      var xhr = this;

      if (xhr.__sleepSetupIsCartMutation) {
        xhr.addEventListener('loadend', function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            setTimeout(function () {
              document.dispatchEvent(new CustomEvent('sleep-setup:cart-changed'));
            }, 50);
          }
        });
      }

      var isSilent = !!(xhr.__sleepSetupHeaders && xhr.__sleepSetupHeaders['X-SW-Silent-Cart-Sync']);

      if (xhr.__sleepSetupIsCartAdd && !isSilent && typeof body === 'string') {
        var parsedBody = null;
        try { parsedBody = JSON.parse(body); } catch (e) { parsedBody = null; }

        if (parsedBody && parsedBody.id != null) {
          var fp = fingerprintAddBody(parsedBody);
          var pending = fp && pendingAddRequests[fp];
          var now = Date.now();

          if (pending && (now - pending.ts) < DUPLICATE_ADD_WINDOW_MS) {
            console.warn('🛑 Duplicate /cart/add.js XHR request collapsed (same variant+properties within ' + DUPLICATE_ADD_WINDOW_MS + 'ms) — mirroring the in-flight request instead of adding again.');
            pending.promise.then(function (res) {
              mirrorResponseOntoXhr(xhr, res);
            }).catch(function () {
              mirrorXhrError(xhr);
            });
            return;
          }

          if (fp) {
            var xhrPromise = new Promise(function (resolve, reject) {
              xhr.addEventListener('load', function () { resolve(xhr); });
              xhr.addEventListener('error', function () { reject(new Error('xhr error')); });
              xhr.addEventListener('abort', function () { reject(new Error('xhr abort')); });
            }).then(function (finishedXhr) {
              delete pendingAddRequests[fp];
              return finishedXhr;
            }).catch(function (err) {
              delete pendingAddRequests[fp];
              throw err;
            });
            pendingAddRequests[fp] = { promise: xhrPromise, ts: now };
          }
        }
      }

      return _origXhrSend.apply(this, arguments);
    };
  }

  var widgetRenderDebounce = null;
  function debouncedWidgetRender() {
    clearTimeout(widgetRenderDebounce);
    widgetRenderDebounce = setTimeout(function () {
      activeInstances.forEach(function (el) {
        if (el.isConnected) el.render();
      });
    }, 350);
  }

  document.addEventListener('sleep-setup:cart-changed', function () {
    debouncedWidgetRender();
    if (window.sleepwellRefreshHeaderSection) window.sleepwellRefreshHeaderSection();
  });
  document.addEventListener('cart:refresh', function () {
    debouncedWidgetRender();
    if (window.sleepwellRefreshHeaderSection) window.sleepwellRefreshHeaderSection();
  });
  document.addEventListener('cart:updated', function () {
    debouncedWidgetRender();
  });

  class SleepSetupWidget extends HTMLElement {
    constructor() {
      super();
      this._renderSeq = 0;
      this._onClick = this.handleClick.bind(this);
    }

    grid() {
      return this.querySelector('.sleep-setup-grid');
    }

   connectedCallback() {
      if (!this.grid()) return;

      if (activeInstances.indexOf(this) === -1) activeInstances.push(this);

      this.addEventListener('click', this._onClick);

      debouncedWidgetRender();

      if (!this._swGridWipeObserver) {
        var self = this;
        // ✅ BAAD ME
this._swGridWipeObserver = new MutationObserver(function () {
  var liveGrid = self.grid();
  if (liveGrid && liveGrid.children.length === 0 && self.style.display !== 'none' && self.isConnected) {
    if (self._lastGridHTML) {
      // Cached HTML ko turant (synchronously) wapas daal do — koi blank/skeleton flash nahi
      liveGrid.innerHTML = self._lastGridHTML;
      refreshJudgeMeBadgesWithRetries();
    }
    console.log('🩹 Sleep Setup grid found empty after external morph — restored cache, revalidating silently');
    debouncedWidgetRender(); // background me chup-chaap verify karega
  }
});
        this._swGridWipeObserver.observe(this, { childList: true, subtree: true });
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      var idx = activeInstances.indexOf(this);
      if (idx !== -1) activeInstances.splice(idx, 1);
    }

    showSkeleton() {
      var html = '';
      for (var i = 0; i < LIMIT; i++) {
        html +=
          '<div class="sleep-setup-skeleton-card">' +
            '<div class="ss-skel-row">' +
              '<div class="ss-skel-img"></div>' +
              '<div style="flex:1;">' +
                '<div class="ss-skel-line short"></div>' +
                '<div class="ss-skel-line long"></div>' +
                '<div class="ss-skel-line short"></div>' +
              '</div>' +
            '</div>' +
          '</div>';
      }
      var liveGrid = this.grid();
      if (liveGrid) liveGrid.innerHTML = html;
    }

    render() {
      var self = this;
      var mySeq = ++this._renderSeq;

      var startGrid = this.grid();
      if (startGrid && startGrid.children.length === 0) {
        this.showSkeleton();
      }

      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (mySeq !== self._renderSeq) return;
          var shouldShow = (cart.item_count || 0) !== 0;

          if (!shouldShow) {
            var g1 = self.grid();
            if (self.style.display !== 'none' || (g1 && g1.innerHTML !== '')) {
              self.style.display = 'none';
              if (g1) g1.innerHTML = '';
              self._lastRenderSignature = null;
            }
            return;
          }

          fetchShopifyImages(function () {
            if (mySeq !== self._renderSeq) return;

           determineDisplayProducts(function (curated, cartHandles) {
              if (mySeq !== self._renderSeq) return;

              // Signature me ab cart ke handles bhi shaamil hain —
              // warna Sleep Setup se item add karne par (jo cart badalta
              // hai par curated list nahi) signature same rehta tha, to
              // neeche wala early-return re-filter skip kar deta tha aur
              // add kiya hua item ka card refresh tak dikhta rehta tha.
              var signature = JSON.stringify({
                curated: curated.map(function (e) {
                  return [e.name, e.targetSize ? e.targetSize.label : null, e.sizeMatchOnly || false];
                }),
                cart: (cartHandles || []).slice().sort()
              });
              var sigGrid = self.grid();
              var hasRealCards = sigGrid && sigGrid.querySelector('.ss-product-card');
              if (signature === self._lastRenderSignature && hasRealCards) {
                self.style.display = '';
                return;
              }

              //self.showSkeleton();

              var categoryIds = [];
              curated.forEach(function (entry) {
                if (categoryIds.indexOf(entry.categoryId) === -1) categoryIds.push(entry.categoryId);
              });

              var poolByCategory = {};
              var pending = categoryIds.length;

              function checkPending() {
                pending--;
                if (pending === 0) finalizeRender();
              }

              if (categoryIds.length === 0) {
                finalizeRender();
              } else {
                categoryIds.forEach(function (categoryId) {
                  fetchCategoryProductList(categoryId, function (list) {
                    if (mySeq !== self._renderSeq) return;
                    poolByCategory[categoryId] = list;
                    checkPending();
                  });
                });
              }

              function finalizeRender() {
                if (mySeq !== self._renderSeq) return;

                var seenSizedProductIds = {};

                var toRender = curated.map(function (entry) {
                  var categoryPool = poolByCategory[entry.categoryId] || [];
                  var product;
                  var apiSize = null;
                  var apiVariant = null;

                  if (entry.sizeMatchOnly) {
                    var protectorProduct = findProductByName(categoryPool, CURATED_PRODUCTS.shieldProtector.name);
                    if (protectorProduct && protectorProduct.variants && protectorProduct.variants.length) {
                      var sizedVariant = findClosestVariant(protectorProduct.variants, entry.targetSize, seenSizedProductIds);
                      if (sizedVariant) {
                        if (seenSizedProductIds[sizedVariant.variant_id]) {
                          return null;
                        }
                        seenSizedProductIds[sizedVariant.variant_id] = true;
                        product = protectorProduct;
                        apiVariant = sizedVariant;
                        apiSize = {
                          length: sizedVariant.length,
                          breadth: sizedVariant.breadth,
                          thickness: sizedVariant.thickness || sizedVariant.height || null,   // 🆕
                          label: [sizedVariant.length, sizedVariant.breadth].sort(function (a, b) { return b - a; }).join('X')
                        };
                      }
                    }
                    if (!product) {
                      product = findProductByName(categoryPool, CURATED_PRODUCTS.shieldProtector.name);
                    }
                  } else {
                    product = findProductByName(categoryPool, entry.name);
                  }

                  if (!product) {
                    console.warn(
                      'Sleep setup: curated product not found:', entry.name, 'in category', entry.categoryId
                    );
                    return null;
                  }
                  var handleSlug = getShopifyHandle(product);
                  if (cartHandles.indexOf(handleSlug) !== -1) return null;
                  return { entry: entry, product: product, handleSlug: handleSlug, apiSize: apiSize, apiVariant: apiVariant };
                });

                var cardsBySlot = new Array(toRender.length);
                var pendingCards = toRender.filter(Boolean).length;

                if (pendingCards === 0) { finishGrid(); return; }

                toRender.forEach(function (t, idx) {
                  if (!t) return;

                  function place(card) {
                    cardsBySlot[idx] = card;
                    pendingCards--;
                    if (pendingCards === 0) finishGrid();
                  }

                  if (t.apiVariant) {
                    var av = t.apiVariant;
                    var originalPrice = parseFloat(av.price) || 0;
                    var pDiscount = parseFloat(t.product.vdiscount) > 0
                      ? parseFloat(t.product.vdiscount)
                      : (parseFloat(t.product.discountpercent) > 0
                          ? parseFloat(t.product.discountpercent)
                          : (parseFloat(av.discount) || 0));
                    var discountedPrice = pDiscount > 0
                      ? originalPrice * (1 - pDiscount / 100)
                      : originalPrice;

                    var priceData = {
                      salePrice: discountedPrice,
                      comparePrice: pDiscount > 0 ? originalPrice : 0,
                      discount: Math.round(pDiscount),
                      discountType: pDiscount ? (Math.round(pDiscount) + '% off') : ''
                    };

                  resolveVariantForSize(t.handleSlug, t.apiSize, function (variant) {
  if (mySeq !== self._renderSeq) return;
  var rawThk = (t.apiSize && t.apiSize.thickness) || av.thickness || av.height || t.product.thickness;
  place(createProductCard(t.product, t.handleSlug, {
    sizeLabel: t.apiSize ? t.apiSize.label : null,
    variantId: variant ? variant.id : null,
    priceOverride: priceData,
    categoryId: t.entry.categoryId,
    length: t.apiSize ? t.apiSize.length : null,
    breadth: t.apiSize ? t.apiSize.breadth : null,
    thickness: !isNaN(rawThk) ? rawThk : 0,
    lengthMm:    av.lengthMm    != null ? av.lengthMm    : (t.product.lengthMm    != null ? t.product.lengthMm    : ''),   // 🆕
    breadthMm:   av.breadthMm   != null ? av.breadthMm   : (t.product.breadthMm   != null ? t.product.breadthMm   : ''),   // 🆕
    thicknessMm: av.thicknessMm != null ? av.thicknessMm : (t.product.thicknessMm != null ? t.product.thicknessMm : '')    // 🆕
  }));
});
                  } else {
                    // v10 — every card (Pillow, Sofa — anything that
                    // isn't the size-matched Protector) now resolves
                    // its real Shopify variant by SIZE at render time,
                    // exactly like the Protector path above, instead
                    // of leaving handleClick() to guess later.
                    var directLength = parseFloat(t.product.length);
                    var directBreadth = parseFloat(t.product.breadth);
                    var directTargetSize = null;
                    if (directLength && directBreadth) {
                      var directDims = [directLength, directBreadth].sort(function (a, b) { return b - a; });
                      directTargetSize = { label: directDims[0] + 'X' + directDims[1], area: directDims[0] * directDims[1] };
                    }

                    if (directTargetSize) {
                      resolveVariantForSize(t.handleSlug, directTargetSize, function (variant) {
                        if (mySeq !== self._renderSeq) return;
                        place(createProductCard(t.product, t.handleSlug, {
                          categoryId: t.entry.categoryId,
                          variantId: variant ? variant.id : null
                        }));
                      });
                    } else {
                      // v11 — no usable dimensions on this product at
                      // all. resolveVariantForCard() (handleClick()'s
                      // fallback) no longer matches by price — it just
                      // returns the product's single/first available
                      // variant, since there's nothing more specific
                      // to match on once size isn't available either.
                      console.warn('Sleep setup: product "' + (t.product.listing_title || t.product.zoneTitle) + '" has no usable length/breadth — cannot pre-resolve its Shopify variant by size.');
                      place(createProductCard(t.product, t.handleSlug, { categoryId: t.entry.categoryId }));
                    }
                  }
                });

                function finishGrid() {
                  if (mySeq !== self._renderSeq) return;
                  var finalGrid = self.grid();
                  if (!finalGrid) return;
                  finalGrid.innerHTML = '';
                  cardsBySlot.forEach(function (card) {
                    if (!card) return;
                    finalGrid.appendChild(card);
                    injectJudgeMe(card, card.dataset.handle);
                  });
                  refreshJudgeMeBadgesWithRetries();
                  self.style.display = finalGrid.children.length === 0 ? 'none' : '';
                  self._lastRenderSignature = signature;
                  self._lastGridHTML = finalGrid.innerHTML;

                  requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                      var dialog = document.querySelector('cart-drawer-component dialog');
                      if (dialog) {
                        dialog.style.top = '0px';
                      }
                    });
                  });
                }
              }
            });
          });
        })
        .catch(function () {});
    }

    handleClick(e) {
      var self = this;
      var btn = e.target.closest('.sw-ss-atc');
      if (!btn || btn.disabled) return;

      var card = btn.closest('.ss-product-card');
      var handle = card ? card.dataset.handle : '';
      var shownPrice = parseFloat(btn.dataset.price || '0');
      var comparePrice = parseFloat(btn.dataset.compare || '0');
      var discountPct = parseFloat(btn.dataset.discount || '0');
      var knownVariantId = btn.dataset.variantId;
      var cardProductId = card ? card.dataset.productId : '';
      var cardCategoryId = card ? card.dataset.categoryId : ''; // v8
      var cardLength = card ? card.dataset.length : '';
      var cardBreadth = card ? card.dataset.breadth : '';
      var cardThickness = card ? card.dataset.thickness : '';
      var cardLengthMm = card ? card.dataset.lengthMm : '';
var cardBreadthMm = card ? card.dataset.breadthMm : '';
var cardThicknessMm = card ? card.dataset.thicknessMm : '';

      if (!handle || !cardProductId) {
        console.error('Sleep Setup: missing handle/productId', { handle: handle, cardProductId: cardProductId });
        return;
      }

      var orig = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      window.__swSleepSetupWriting = true;

      function proceedWithVariant(variant) {
        if (!variant || !variant.id) {
          btn.textContent = 'Unavailable';
          window.__swSleepSetupWriting = false;
          setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1800);
          return;
        }

var finalThickness = (cardThickness !== undefined && cardThickness !== '') ? cardThickness : 0;

var cleanProps = {
  '_api_price':        String(shownPrice),
  '_api_compare':      String(comparePrice || 0),
  '_api_discount':     String(discountPct || 0),
  '_product_id':       String(cardProductId),
  '_length':           String(cardLength || 72),
  '_breadth':          String(cardBreadth || 30),
  '_thickness':        String(finalThickness),
  '_lengthMm':         String(cardLengthMm    || ''),   // 🆕
  '_breadthMm':        String(cardBreadthMm   || ''),   // 🆕
  '_thicknessMm':      String(cardThicknessMm || ''),   // 🆕
  '_from_sleep_setup': '1',
  '_sw_category':      String(cardCategoryId || ''),
  '_ss_ts':            String(Date.now())
};

        // 🆕 FAIL-CLOSED: category-required props missing ho to add mat karo.
        var __swCheck = window.__swValidateLineProps ? window.__swValidateLineProps(cleanProps) : { ok: true, missing: [] };
        if (!__swCheck.ok) {
          console.error('🛑 Sleep Setup ATC refused — missing:', __swCheck.missing, cleanProps);
          btn.textContent = 'Unavailable';
          window.__swSleepSetupWriting = false;
          setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1800);
          return;
        }

        function forceDomPrice(itemKey) {
          if (!itemKey) return;
          var cardEl = document.querySelector('.custom-cart-card[data-key="' + CSS.escape(itemKey) + '"]');
          if (!cardEl) return;

          var saleEl    = cardEl.querySelector('[data-price-final]');
          var compareEl = cardEl.querySelector('[data-price-compare]');
          var discEl    = cardEl.querySelector('[data-price-discount]');

          if (saleEl) saleEl.textContent = '₹' + Math.round(shownPrice);

          if (comparePrice > shownPrice) {
            if (!compareEl) {
              compareEl = document.createElement('s');
              compareEl.className = 'custom-price-compare';
              compareEl.setAttribute('data-price-compare', '');
              saleEl && saleEl.insertAdjacentElement('afterend', compareEl);
            }
            compareEl.textContent = '₹' + Math.round(comparePrice);
            compareEl.style.display = '';

            if (!discEl) {
              discEl = document.createElement('span');
              discEl.className = 'custom-discount-badge';
              discEl.setAttribute('data-price-discount', '');
              compareEl.insertAdjacentElement('afterend', discEl);
            }
            discEl.textContent = Math.round(discountPct) + '% off';
            discEl.style.display = '';
          } else {
            if (compareEl) compareEl.style.display = 'none';
            if (discEl) discEl.style.display = 'none';
          }
        }

        function forceHeal(variantId, attempt) {
          return fetch('/cart.js', { cache: 'no-store' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var idx = -1;
              var itemKey = null;
              for (var i = 0; i < cart.items.length; i++) {
                if (String(cart.items[i].variant_id) === String(variantId)) {
                  idx = i;
                  itemKey = cart.items[i].key;
                  break;
                }
              }
              if (idx === -1) return cart;

              var item = cart.items[idx];

              
              if (item.properties && item.properties['_is_free_gift'] === 'true') {
                console.error('🛑 forceHeal: matched line ek FREE GIFT hai (key: ' + item.key + ') — is line ko touch nahi kiya jaayega.');
                return cart;
              }

              if (itemKey) {
                window.__swCartItemPriceData = window.__swCartItemPriceData || {};
                window.__swCartItemPriceData[itemKey] = {
                  salePrice: shownPrice,
                  comparePrice: comparePrice,
                  discount: discountPct,
                  discountType: discountPct ? Math.round(discountPct) + '% off' : ''
                };
                forceDomPrice(itemKey);
              }

              var curPid   = (item.properties && item.properties['_product_id']) || '';
              var curPrice = parseFloat((item.properties && item.properties['_api_price']) || 0);

              if (String(curPid) === String(cardProductId) && Math.abs(curPrice - shownPrice) < 1) {
                return cart;
              }

              console.warn('🛡️ HEAL attempt ' + attempt, { curPid: curPid, curPrice: curPrice, expectedPid: cardProductId, shownPrice: shownPrice });

              var fixed = Object.assign({}, item.properties || {}, cleanProps);
              delete fixed._variant_id;
              delete fixed._color;
              delete fixed.hl_pin;
              delete fixed._extra_total;
              delete fixed._city_id;
              delete fixed._city_name;
              delete fixed._state_id;
              delete fixed._state_name;

              return fetch('/cart/change.js', {
                method: 'POST',
                cache: 'no-store',
                headers: {
                  'Content-Type': 'application/json',
                  'X-SW-Silent-Cart-Sync': '1'
                },
                body: JSON.stringify({
                  id: item.key,
                  quantity: item.quantity,
                  properties: fixed
                })
              })
              .then(function (r) { return r.json(); })
              .then(function () {
                return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
              })
              .catch(function (e) {
                console.error('heal failed', e);
                return cart;
              });
            });
        }

        fetch('/cart/add.js', {
          method: 'POST',
          cache: 'no-store',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variant.id,
            quantity: 1,
            properties: cleanProps
          })
        })
        .then(function (r) {
          if (!r.ok) throw new Error('add ' + r.status);
          return r.json();
        })
        .then(function () {
          return forceHeal(variant.id, 1);
        })
        .then(function (cart) {
          // v10 — REMOVED the redundant setTimeout(forceHeal(variant.id, 2), 400)
          // second pass. forceHeal(1) above already only WRITES anything if it
          // detects a genuine mismatch (curPid/curPrice check) — this second,
          // always-scheduled call was a guaranteed EXTRA silent /cart/change.js
          // write on every single add, and every such write triggers Shopify's
          // OWN native cart-drawer re-render regardless of our
          // X-SW-Silent-Cart-Sync header (that header only suppresses OUR
          // listeners, not Shopify's built-in cart-items-component). This was a
          // direct, confirmed contributor to the reported cart flickering.

          btn.textContent = 'Added';
          btn.style.background = '#27ae60';

          document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-count, .cart-bubble__text-count')
            .forEach(function (el) { el.textContent = cart.item_count || 0; });

          // v9 — BUGFIX: a single add-to-cart action fires MULTIPLE
          // events ('sleep-setup:cart-changed', 'cart:refresh',
          // 'cart:updated') as it propagates through
          // dispatchRealCartAddEvent()/swRefreshCartDrawer(). The old
          // boolean flag was consumed (set back to false) by
          // whichever of those events the price-sync listener saw
          // FIRST — every subsequent event from the SAME add-to-cart
          // action then fell through and scheduled a sync anyway.
          // That extra, unintended sync is what could re-fetch and
          // re-persist `_api_price` for EVERY real cart item shortly
          // after each sleep-setup add — including items that had
          // nothing to do with the click. A time WINDOW (not a
          // one-shot boolean) correctly suppresses all events that
          // arrive from the same action, however many there are.
          window.__swSkipPriceSyncUntil = Date.now() + 1500;
          dispatchRealCartAddEvent(cart, handle);

          for (var ci = 0; ci < (cart.items || []).length; ci++) {
            if (String(cart.items[ci].variant_id) === String(variant.id)) {
              var addedKey = cart.items[ci].key;
              window.__swCartItemPriceData = window.__swCartItemPriceData || {};
              window.__swCartItemPriceData[addedKey] = {
                salePrice: shownPrice,
                comparePrice: comparePrice,
                discount: discountPct,
                discountType: discountPct ? Math.round(discountPct) + '% off' : ''
              };
              forceDomPrice(addedKey);
              break;
            }
          }

          debouncedWidgetRender();

          setTimeout(function () {
            btn.textContent = orig;
            btn.style.background = '';
            btn.disabled = false;
            window.__swSleepSetupWriting = false;
          }, 2000);
        })
        .catch(function (err) {
          console.error('Sleep Setup add failed', err);
          btn.textContent = 'Failed';
          window.__swSleepSetupWriting = false;
          setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1800);
        });
      }

      // v10 — every card now gets its variantId PRE-RESOLVED by SIZE
      // v10/v11 — every card now gets its variantId PRE-RESOLVED by
      // SIZE at render time (see finalizeRender()'s else-branch
      // above), so `knownVariantId` should be present for virtually
      // every click. resolveVariantForCard() only still runs for the
      // rare edge case where a product had no usable length/breadth
      // to match by at render time — and it no longer matches by
      // price at all, it just returns the product's single/first
      // available variant.
      if (knownVariantId) {
        proceedWithVariant({ id: knownVariantId });
      } else {
        console.warn('Sleep Setup: no pre-resolved variantId for "' + handle + '" — falling back to single/first-available-variant lookup. Check why this product had no usable size at render time.');
        resolveVariantForCard(handle, proceedWithVariant);
      }
    }
  }

  customElements.define('sleep-setup-widget', SleepSetupWidget);

  function patchCartTotalOnLoad() {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartTotalsUI(cart); })
      .catch(function () {});
  }
})();

/* ── Flash killer: watch for new cart cards and force correct price from cache ── */
(function () {
  if (window.__swPriceFlashKiller) return;
  window.__swPriceFlashKiller = true;

  var observer = new MutationObserver(function (mutations) {
    if (!window.__swCartItemPriceData) return;

    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        var cards = [];
        if (node.classList && node.classList.contains('custom-cart-card')) {
          cards = [node];
        } else if (node.querySelectorAll) {
          cards = Array.from(node.querySelectorAll('.custom-cart-card'));
        }

        cards.forEach(function (card) {
          var key = card.getAttribute('data-key');
          if (!key) return;
          var data = window.__swCartItemPriceData[key];
          if (!data) return;

          var saleEl    = card.querySelector('[data-price-final]');
          var compareEl = card.querySelector('[data-price-compare]');
          var discEl    = card.querySelector('[data-price-discount]');

          if (saleEl) {
            saleEl.textContent = '₹' + Math.round(data.salePrice);
          }

          if (data.comparePrice > data.salePrice) {
            if (!compareEl && saleEl) {
              compareEl = document.createElement('s');
              compareEl.className = 'custom-price-compare';
              compareEl.setAttribute('data-price-compare', '');
              saleEl.insertAdjacentElement('afterend', compareEl);
            }
            if (compareEl) {
              compareEl.textContent = '₹' + Math.round(data.comparePrice);
              compareEl.style.display = '';
            }

            if (!discEl && compareEl) {
              discEl = document.createElement('span');
              discEl.className = 'custom-discount-badge';
              discEl.setAttribute('data-price-discount', '');
              compareEl.insertAdjacentElement('afterend', discEl);
            }
            if (discEl) {
              discEl.textContent = data.discountType || (Math.round(data.discount) + '% off');
              discEl.style.display = '';
            }
          } else {
            if (compareEl) compareEl.style.display = 'none';
            if (discEl) discEl.style.display = 'none';
          }
        });
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  console.log('%c✅ Price flash killer active', 'color:lime');
})();

/* ══════════════════════════════════════════════════════════════════
   🚚 DELIVERY ESTIMATE
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (window.__swDeliveryIntervalId) {
    clearInterval(window.__swDeliveryIntervalId);
    window.__swDeliveryIntervalId = null;
  }

  console.log('🚚 Delivery estimate — single cached value, no repeat API calls');

var DELIVERY_API_URL = 'https://sf-backend.mysleepwell.com/s1/product/citybypincode';
var FETCH_TIMEOUT_MS = 8000;

  window.__swCachedDeliveryEstimate = window.__swCachedDeliveryEstimate || null;
  var fetchInFlight = null;

  function getCachedEstimate() { return window.__swCachedDeliveryEstimate; }
  function setCachedEstimate(v) { window.__swCachedDeliveryEstimate = v; }

function formatDeliveryDate(days) {
    var d = new Date();
    d.setDate(d.getDate() + (parseInt(days, 10) || 0));
    var parts = d.toDateString().split(' ');
    parts[0] = parts[0].toUpperCase();
    return parts.join(' ');
  }
  
  window.__swFormatDeliveryDate = formatDeliveryDate;

  function setRowText(row, text, isError) {
    if (!row.isConnected) return;
    var span = row.querySelector('[data-delivery-text]');
    if (!span) return;
    span.textContent = text;
    span.style.color = isError ? '#cc0000' : '';
    span.style.fontWeight = isError ? '600' : '';
  }

  function isCustomSizeSelected() {
    return sessionStorage.getItem('isCustomSize') === '1';
  }

  function fetchWithTimeout(url, timeoutMs) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, timeoutMs);
    return fetch(url, { signal: controller.signal }).finally(function () {
      clearTimeout(timer);
    });
  }

 function getDimsFromRow(row) {
    var l = parseFloat(row.dataset.itemLength);
    var b = parseFloat(row.dataset.itemBreadth);
    var t = parseFloat(row.dataset.itemThickness);
    // 🆕 Pillow/Protector ke liye default 0, mattress ke liye 6
    var cat = row.dataset.itemCategory || row.dataset.swCategory || '';
    var isPP = (cat === 'pillow' || cat === 'protector');
    return {
      length:    (!isNaN(l) && l > 0) ? l : 72,
      breadth:   (!isNaN(b) && b > 0) ? b : 30,
      thickness: (!isNaN(t) && t >= 0) ? t : (isPP ? 0 : 0)
    };
  }

  function getAnyDirectPidRow(rows) {
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].dataset.itemPid) return rows[i];
    }
    return null;
  }

  function applyToAllRows(rows, estimate) {
    rows.forEach(function (row) {
      if (!estimate) {
        setRowText(row, 'Delivery estimate unavailable', true);
      } else if (!estimate.serviceable) {
        setRowText(row, 'Sorry, delivery not available at this location', true);
      } else {
        setRowText(row, 'Estimated delivery on ' + formatDeliveryDate(estimate.days), false);
      }
    });
  }

  function fetchEstimateOnce(pincode, pidRow) {
    var pid = pidRow.dataset.itemPid;
    var dims = getDimsFromRow(pidRow);
    var url = DELIVERY_API_URL + '/' + pincode + '/' + pid +
      '?l=' + dims.length + '&b=' + dims.breadth + '&t=' + dims.thickness + '&q=1&_=' + Date.now();

    return fetchWithTimeout(url, FETCH_TIMEOUT_MS)
      .then(function (res) {
        if (!res.ok) throw new Error('API returned status ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data || (Array.isArray(data) && data.length === 0)) {
          return { serviceable: false, days: null, pincode: pincode };
        }

        var record = Array.isArray(data) ? data[0] : data;
        var isServiceable = (record.isExits === undefined || record.isExits === 1) &&
                             (record.dstatus === undefined || record.dstatus === 1);
        var hasDays = record.omni_standard_delivery !== undefined && record.omni_standard_delivery !== null;

        if (!isServiceable || !hasDays) {
          return { serviceable: false, days: null, pincode: pincode };
        }

        var days = isCustomSizeSelected()
          ? (record.omni_custom_delivery !== undefined && record.omni_custom_delivery !== null
              ? record.omni_custom_delivery : record.omni_standard_delivery)
          : record.omni_standard_delivery;

        return { serviceable: true, days: days, pincode: pincode };
      });
  }

  function runDeliveryCheck() {
    var rows = document.querySelectorAll('[data-delivery-row]');

    if (!rows.length) {
      setCachedEstimate(null);
      return Promise.resolve();
    }

    var pincode = (localStorage.getItem('kpc_pincode') || '').trim();
    if (!pincode || !/^\d{6}$/.test(pincode)) {
      rows.forEach(function (row) { setRowText(row, 'Add a delivery pincode to see estimated dates', true); });
      return Promise.resolve();
    }

    var cachedEstimate = getCachedEstimate();
    if (cachedEstimate && cachedEstimate.pincode === pincode) {
      applyToAllRows(rows, cachedEstimate);
      return Promise.resolve();
    }

    rows.forEach(function (row) { setRowText(row, 'Checking delivery availability...', false); });

    if (fetchInFlight) {
      return fetchInFlight.then(function () {
        applyToAllRows(document.querySelectorAll('[data-delivery-row]'), getCachedEstimate());
      });
    }

    var pidRow = getAnyDirectPidRow(rows);
    if (!pidRow) {
      console.warn('⚠️ No cart row carries a usable product id — cannot check delivery');
      setCachedEstimate(null);
      applyToAllRows(rows, null);
      return Promise.resolve();
    }

    fetchInFlight = fetchEstimateOnce(pincode, pidRow)
      .then(function (estimate) {
        setCachedEstimate(estimate);
        return estimate;
      })
      .catch(function (err) {
        console.error('❌ Delivery API call failed:', err);
        setCachedEstimate(null);
        return null;
      })
      .finally(function () {
        fetchInFlight = null;
      });

    return fetchInFlight.then(function (result) {
      applyToAllRows(document.querySelectorAll('[data-delivery-row]'), result);
    });
  }
  window.runCartDeliveryChecks = runDeliveryCheck;

  var PLACEHOLDER_TEXT = 'Checking delivery availability...';

  function reconcileRows() {
    var rows = document.querySelectorAll('[data-delivery-row]');

    if (!rows.length) {
      setCachedEstimate(null);
      return;
    }

    var pincode = (localStorage.getItem('kpc_pincode') || '').trim();

    var needsFix = Array.prototype.filter.call(rows, function (row) {
      var span = row.querySelector('[data-delivery-text]');
      return span && span.textContent.trim() === PLACEHOLDER_TEXT;
    });

    if (!needsFix.length) return;

    if (!pincode || !/^\d{6}$/.test(pincode)) {
      needsFix.forEach(function (row) { setRowText(row, 'Add a delivery pincode to see estimated dates', true); });
      return;
    }

    var cachedEstimate = getCachedEstimate();
    if (cachedEstimate && cachedEstimate.pincode === pincode) {
      applyToAllRows(needsFix, cachedEstimate);
      return;
    }

    runDeliveryCheck();
  }

  window.__swDeliveryIntervalId = setInterval(reconcileRows, 1000);
  window.addEventListener('beforeunload', function () {
    clearInterval(window.__swDeliveryIntervalId);
  });

 function init() {
    reconcileRows();
    window.addEventListener('swCartPincodeChanged', function () { setCachedEstimate(null); reconcileRows(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ══════════════════════════════════════════════════════════════════
   💰 LIVE CART ITEM PRICE SYNC
   ══════════════════════════════════════════════════════════════════
   On every cart mutation this fetches the real pincode-based price
   from https://sf-backend.mysleepwell.com/apis/shopify/price/update
   for each REAL cart line and updates the displayed price.

   v8 — this response is ALSO the single source of gift data for
   free-gift.js now. Confirmed shape: data.fullData.forgiftlist is an
   array of gift definitions (gift_prod_name, qty_single, qty_queen,
   qty_king, ...) — same shape productlist/mattress's `.gifts` field
   used to have. Extracted and cached in
   window.__swItemGiftData[itemKey]. syncAllCartItemPrices() returns
   a Promise so free-gift.js can await a fresh pass before reading
   that cache — gift sync makes ZERO network calls of its own now.

   IMPORTANT: free-gift line items (`_is_free_gift: 'true'`) are
   EXCLUDED from this call below (see the `items` filter inside
   syncAllCartItemPrices) — their price must always come straight
   from Shopify's own variant price, never from this API. Do not
   remove that filter.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (window.__swCartPriceSyncInit) return;
  window.__swCartPriceSyncInit = true;

  console.log('💰 Cart item price sync (per-item, key-scoped) — active');

  var NODE_API_URL = 'https://sf-backend.mysleepwell.com';

 // var NODE_API_URL2 = 'https://outlast-drainage-disperser.ngrok-free.dev';
  var PRICE_API_TIMEOUT_MS = 4000;

  function parseFullDimsFromSku(sku) {
    if (!sku) return null;
    var m = String(sku).match(/(\d+(?:\.\d+)?)X(\d+(?:\.\d+)?)X(\d+(?:\.\d+)?)-/i);
    if (!m) return null;
    var length = parseFloat(m[1]);
    var breadth = parseFloat(m[2]);
    var thickness = parseFloat(m[3]);
    if (!length || !breadth) return null;
    return { length: length, breadth: breadth, thickness: thickness };
  }

  window.__swCartItemPriceData = window.__swCartItemPriceData || {};
  window.__swItemGiftData = window.__swItemGiftData || {}; // v8

  function fetchWithTimeout(url, options, timeoutMs) {
    options = options || {};
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, timeoutMs || PRICE_API_TIMEOUT_MS);
    var merged = Object.assign({}, options, { signal: controller.signal });
    return fetch(url, merged).finally(function () { clearTimeout(timer); });
  }

  function getLoc() {
    return {
      cityId:  localStorage.getItem('city_id') || '259',
      stateId: localStorage.getItem('stateId') || '38'
    };
  }

  function getCardEl(itemKey) {
    if (!itemKey) return null;
    try {
      return document.querySelector('.custom-cart-card[data-key="' + CSS.escape(itemKey) + '"]');
    } catch (e) {
      return null;
    }
  }

  function showRowLoading(itemKey) {
    var card = getCardEl(itemKey);
    if (!card) return;
    var row = card.querySelector('[data-price-row]');
    if (row) row.style.opacity = '0.55';
  }

  function clearRowLoading(itemKey) {
    var card = getCardEl(itemKey);
    if (!card) return;
    var row = card.querySelector('[data-price-row]');
    if (row) row.style.opacity = '';
  }

  function renderItemPrice(itemKey, priceData) {
    var card = getCardEl(itemKey);
    if (!card) return;
    var row = card.querySelector('[data-price-row]');
    if (!row) return;

    row.style.opacity = '';

    var saleEl    = row.querySelector('[data-price-final]');
    var compareEl = row.querySelector('[data-price-compare]');
    var discEl    = row.querySelector('[data-price-discount]');
    if (!saleEl) return;

    var sale    = parseFloat(priceData.salePrice) || 0;
    var compare = parseFloat(priceData.comparePrice) || 0;
    var hasDisc = priceData.discount > 0 && sale < compare;

    saleEl.textContent = '₹' + Math.round(sale);

    if (hasDisc) {
      if (!compareEl) {
        compareEl = document.createElement('s');
        compareEl.className = 'custom-price-compare';
        compareEl.setAttribute('data-price-compare', '');
        saleEl.insertAdjacentElement('afterend', compareEl);
      }
      compareEl.textContent = '₹' + Math.round(compare);
      compareEl.style.display = '';

      if (!discEl) {
        discEl = document.createElement('span');
        discEl.className = 'custom-discount-badge';
        discEl.setAttribute('data-price-discount', '');
        compareEl.insertAdjacentElement('afterend', discEl);
      }
      discEl.textContent = priceData.discountType || (Math.round(priceData.discount) + '% off');
      discEl.style.display = '';
    } else {
      if (compareEl) compareEl.style.display = 'none';
      if (discEl) discEl.style.display = 'none';
    }
  }

  window.__swPriceSyncWriting = false;
  window.__swSkipPriceSyncUntil = window.__swSkipPriceSyncUntil || 0; // v9

  var PERSIST_EPSILON = 0.5;
function persistPriceToLine(item, lineKey, priceData) {
    var existingApiPrice = parseFloat(item.properties && item.properties['_api_price']);
    var newSale = parseFloat(priceData.salePrice) || 0;
    var alreadyInSync = !isNaN(existingApiPrice) && Math.abs(existingApiPrice - newSale) < PERSIST_EPSILON;

    // 🆕 _extra_total — was previously never persisted here at all,
    // even though price/update's response carries extraCharge. Items
    // added via Sleep Essentials (or any flow whose add-to-cart call
    // has no access to extraCharge, since the listing API doesn't
    // return it) only ever got _extra_total from THIS sync pass —
    // same pattern sw-pincode-cart-recheck.js already uses.
    var newExtraTotal = String(priceData.extraCharge || 0);
    var existingExtraTotal = (item.properties && item.properties['_extra_total']) || '';
    var extraInSync = newExtraTotal === existingExtraTotal;

    // _delivery_tat — built from the SAME pincode-based estimate the
    // delivery-row UI uses (window.__swCachedDeliveryEstimate, filled
    // by the delivery-estimate script's citybypincode call). Only
    // stamp it once the estimate is available and serviceable.
    var deliveryTat = '';
    var est = window.__swCachedDeliveryEstimate;
    if (est && est.serviceable && est.days != null && typeof window.__swFormatDeliveryDate === 'function') {
      deliveryTat = 'Estimated delivery on ' + window.__swFormatDeliveryDate(est.days);
    }
    var existingTat = (item.properties && item.properties['_delivery_tat']) || '';
    var tatInSync = deliveryTat === '' || deliveryTat === existingTat;

    // Skip the write only if price, extra_total, AND delivery TAT are
    // all already in sync — otherwise we'd never stamp/refresh any of
    // the ones that changed.
    if (alreadyInSync && extraInSync && tatInSync) return Promise.resolve();

var mergedProps = Object.assign({}, item.properties || {});
mergedProps['_api_price']    = newSale;
mergedProps['_api_compare']  = parseFloat(priceData.comparePrice) || 0;
mergedProps['_api_discount'] = parseFloat(priceData.discount) || 0;
mergedProps['_extra_total']  = newExtraTotal;
if (deliveryTat) mergedProps['_delivery_tat'] = deliveryTat;
if (priceData.lengthMm    != null) mergedProps['_lengthMm']    = String(priceData.lengthMm);    // 🆕
if (priceData.breadthMm   != null) mergedProps['_breadthMm']   = String(priceData.breadthMm);   // 🆕
if (priceData.thicknessMm != null) mergedProps['_thicknessMm'] = String(priceData.thicknessMm); // 🆕

    window.__swPriceSyncWriting = true;
    return fetch('/cart/change.js', {
      method: 'POST',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', 'X-SW-Silent-Cart-Sync': '1' },
      body: JSON.stringify({ id: lineKey, quantity: item.quantity, properties: mergedProps })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart/change status ' + r.status); return r.json(); })
      .catch(function (err) {
        console.error('❌ Cart price sync: failed to persist price for line', lineKey, err);
      })
      .finally(function () {
        setTimeout(function () { window.__swPriceSyncWriting = false; }, 600);
      });
  }

  // v8 — CONFIRMED gift field: data.fullData.forgiftlist.
  function extractGiftsFromPriceResponse(data) {
    var list = data && data.fullData && data.fullData.forgiftlist;
    return Array.isArray(list) ? list : [];
  }
function fetchPriceForItem(item, lineKey) {
    var itemKey = item.key;

    if (item.properties && item.properties['_is_free_gift'] === 'true') {
      console.error('🛑 fetchPriceForItem: FREE GIFT item ke liye call hua — refuse kiya.');
      return Promise.resolve();
    }

    var productId = item.properties && item.properties['_product_id'];
    var variantId = item.variant_id;
    if (!productId || !variantId) {
      console.warn('⚠️ Cart price sync: skipping item (no _product_id property) — key:', itemKey, '| title:', item.product_title);
      return Promise.resolve();
    }

    var isCustomSizeItem = !!(item.properties && item.properties['Custom Size']);
    var skuDims = isCustomSizeItem ? null : parseFullDimsFromSku(item.sku);
    var length    = (skuDims && skuDims.length)  || parseFloat(item.properties['_length'])    || 72;
    var breadth   = (skuDims && skuDims.breadth) || parseFloat(item.properties['_breadth'])   || 30;
    // 🆕 Pillow/Protector ke liye default 0, mattress ke liye 6
    var itemCat = item.properties && item.properties['_sw_category'];
    var isPillowOrProtector = (itemCat === 'pillow' || itemCat === 'protector');
    var rawThickness = parseFloat(item.properties['_thickness']);
var thickness = !isNaN(rawThickness) ? rawThickness : (isPillowOrProtector ? 0 : 0);

    if (skuDims && (skuDims.length != parseFloat(item.properties['_length']) || skuDims.breadth != parseFloat(item.properties['_breadth']))) {
      console.warn('⚠️ Cart price sync: item "' + (item.product_title || item.title) + '" (key ' + itemKey + ') has _length/_breadth properties (' + item.properties['_length'] + 'X' + item.properties['_breadth'] + ') that DON\'T match its real SKU-derived size (' + skuDims.length + 'X' + skuDims.breadth + '). Using the SKU-derived (correct) length/breadth for this request — thickness still comes from properties since SKU can\'t represent decimals precisely.');
    }
    var loc = getLoc();

    var qty = parseInt(item.quantity, 10) || 1;

    var req = {
      productId: productId,
      variantId: variantId,
      cityId:    parseInt(loc.cityId, 10)  || 259,
      stateId:   parseInt(loc.stateId, 10) || 38,
      length:    length,
      breadth:   breadth,
      thickness: thickness,
      type: 1,
      quantity: qty,
      category: itemCat || ''
    };

    showRowLoading(itemKey);

    return fetchWithTimeout(NODE_API_URL + '/apis/shopify/price/update', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(req)
    }, PRICE_API_TIMEOUT_MS)
      .then(function (res) {
        if (!res.ok) throw new Error('Price API status ' + res.status);
        return res.json();
      })
      .then(function (data) {
        // v8 — pull gift info out of this SAME response, so
        // free-gift.js never needs its own productlist/mattress call.
        var gifts = extractGiftsFromPriceResponse(data);
        window.__swItemGiftData[itemKey] = gifts;

        // v14 — diagnostic: if this is a mattress line and the RAW
        // response genuinely had no forgiftlist (or an empty one),
        // say so explicitly here — this is the definitive signal for
        // whether the backend actually returned gift data for THIS
        // exact request (productId/cityId/stateId/dims), as opposed
        // to a caching/timing issue on our side. If you see this log
        // for a product you KNOW has gifts configured for this
        // city/state, the request payload or the backend response
        // itself is where to look next — not this file's caching.
        if (item.properties && item.properties['_sw_category'] === 'mattress') {
          if (gifts.length) {
            console.log('🎁 Cart price sync: gift data cached for mattress item', itemKey, '→', gifts.length, 'gift(s):', gifts.map(function (g) { return g.gift_prod_name; }));
          } else {
            console.warn('🎁 Cart price sync: price/update response for mattress item', itemKey, '(_product_id ' + req.productId + ', cityId ' + req.cityId + ', stateId ' + req.stateId + ') had NO gift data in data.fullData.forgiftlist. Raw response:', data);
          }
        }

        if (!data || !data.success || !data.priceData) {
          console.warn('⚠️ Cart price sync: no usable priceData for item key', itemKey, data);
          clearRowLoading(itemKey);
          return;
        }

var p = Object.assign({}, data.priceData);
var __fd = data.fullData || {};
p.lengthMm    = __fd.lengthMm    != null ? __fd.lengthMm    : null;   // 🆕
p.breadthMm   = __fd.breadthMm   != null ? __fd.breadthMm   : null;   // 🆕
p.thicknessMm = __fd.thicknessMm != null ? __fd.thicknessMm : null;   // 🆕
if (data.shopifyData && data.shopifyData.compare_at_price) {
          var sc = parseFloat(data.shopifyData.compare_at_price);
          if (sc > p.salePrice && !p.discount) {
            p.comparePrice = sc;
            var pct = Math.round((sc - p.salePrice) / sc * 100);
            p.discount = pct;
            p.discountType = pct + '% off';
          }
        }

        var realPrice = (parseFloat(item.final_price) || 0) / 100;
        if (realPrice > 0 && parseFloat(p.salePrice) < realPrice) {
          console.warn('💰 Cart price sync: fetched price (₹' + p.salePrice + ') is LOWER than the item\'s real Shopify price (₹' + realPrice + ') for "' + (item.product_title || item.title) + '" — using the real price instead so the cart never under-quotes what checkout will charge.');
          p.salePrice = realPrice;
          p.comparePrice = 0;
          p.discount = 0;
          p.discountType = '';
        }

        // v9 — the check above only ever caught the fetched price
        // being TOO LOW. The pillow/Sofa-price mix-up bug showed the
        // opposite failure mode: a fetched salePrice wildly HIGHER
        // than the item's own real Shopify price (₹8499 vs a real
        // ₹383 pillow) — that got persisted as-is because it isn't
        // "lower". realPrice comes straight from Shopify itself (the
        // one number in this whole flow that cannot be wrong), so any
        // fetched price that's more than ~5x away from it — in either
        // direction — is almost certainly a mismatched/misrouted
        // response, not a genuine price. Refuse to persist it and
        // keep whatever was showing before instead of corrupting the
        // cart with a number that could belong to a different product.
        if (realPrice > 0) {
          var deviationRatio = parseFloat(p.salePrice) / realPrice;
          if (deviationRatio > 5 || deviationRatio < 0.2) {
            console.error('🚨 Cart price sync: fetched price ₹' + p.salePrice + ' for "' + (item.product_title || item.title) + '" (key ' + itemKey + ') is implausibly far from its real Shopify price ₹' + realPrice + ' (ratio ' + deviationRatio.toFixed(2) + '×). Refusing to persist — this looks like a wrong/misrouted price/update response, possibly for a different product. Raw response:', data);
            clearRowLoading(itemKey);
            return;
          }
        }

        if (!p.comparePrice || !p.discount) {
          console.warn('⚠️ Cart price sync: API returned NO compare/discount for item key', itemKey, '| raw priceData:', data.priceData, '— compare price will stay hidden for this item until the API itself returns one.');
        }

        window.__swCartItemPriceData[itemKey] = p;
        renderItemPrice(itemKey, p);

        return persistPriceToLine(item, lineKey, p);
      })
      .catch(function (err) {
        console.error('❌ Cart price sync failed for item key', itemKey, ':', err);
        clearRowLoading(itemKey);
      });
  }

  var syncInFlight = false;
  var syncQueued = false;
  var lastSyncedCartSignature = null;
  var lastSyncPromise = Promise.resolve(); // v8 — resolved once the most recent pass finishes

  function cartItemsSignature(items) {
    return items.map(function (it) { return it.key + ':' + it.quantity; }).sort().join('|');
  }

  // v8 — now returns a Promise. free-gift.js awaits this before
  // reading window.__swItemGiftData, so gift sync always sees fresh
  // data without making its own network call.
  function syncAllCartItemPrices() {
    if (window.__swDrawerMorphInFlight) {
      return new Promise(function (resolve) {
        setTimeout(function () { resolve(syncAllCartItemPrices()); }, 150);
      });
    }
    if (syncInFlight) { syncQueued = true; return lastSyncPromise; }
    syncInFlight = true;

    lastSyncPromise = fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // NOTE: free-gift line items are excluded here on purpose —
        // their price must always come straight from Shopify, never
        // from price/update. Do not remove this filter.
        var items = (cart.items || []).filter(function (it) {
          return !(it.properties && it.properties['_is_free_gift'] === 'true');
        });
        if (!items.length) { lastSyncedCartSignature = ''; return Promise.resolve(); }

        // v14 — BUGFIX: the "signature unchanged, skip" shortcut below
        // is a pure performance optimization, but it has a real failure
        // mode — if the VERY FIRST sync pass for a mattress line didn't
        // manage to cache gift data (e.g. it ran before city/state was
        // resolved, or the price/update response was momentarily
        // incomplete), every SUBSEQUENT call sees an "unchanged" cart
        // signature and skips entirely — window.__swItemGiftData for
        // that item's key then never gets populated, ever, until its
        // quantity changes. Force a real pass whenever any mattress
        // item currently in the cart has no cached gift data yet,
        // regardless of whether the cart signature "looks" unchanged.
        var anyMattressMissingGiftData = items.some(function (it) {
          var isMattress = it.properties && it.properties['_sw_category'] === 'mattress';
          if (!isMattress) return false;
          return !(window.__swItemGiftData && window.__swItemGiftData[it.key]);
        });

        var signature = cartItemsSignature(items);
        if (signature === lastSyncedCartSignature && !anyMattressMissingGiftData) {
          console.log('💰 Cart price sync: cart unchanged since last sync — skipping redundant pass.');
          return Promise.resolve();
        }
        if (signature === lastSyncedCartSignature && anyMattressMissingGiftData) {
          console.log('💰 Cart price sync: cart signature unchanged, but a mattress item is still missing cached gift data — running anyway.');
        }

        console.log('💰 Cart price sync: refreshing', items.length, 'item(s) via price/update API');
        return Promise.all(items.map(function (item) {
          return fetchPriceForItem(item, item.key);
        })).then(function () {
          lastSyncedCartSignature = signature;
        });
      })
      .catch(function (err) {
        console.error('❌ Cart price sync: could not read /cart.js:', err);
      })
      .finally(function () {
        syncInFlight = false;
        if (syncQueued) {
          syncQueued = false;
          setTimeout(syncAllCartItemPrices, 150);
        }
      });

    return lastSyncPromise;
  }
  window.__swSyncAllCartItemPrices = syncAllCartItemPrices;

  var debounceTimer = null;
  function scheduleSync(delay) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncAllCartItemPrices, delay || 350);
  }

  // v10 — REMOVED: this used to re-run syncAllCartItemPrices() (which
  // fetches price/update AND writes /cart/change.js for EVERY real
  // cart item) on every single 'sleep-setup:cart-changed' /
  // 'cart:refresh' / 'cart:updated' / 'cart:change' event — i.e. on
  // every add, remove, and quantity change in the cart, for every item
  // already in it. Each of those per-item /cart/change.js writes
  // triggers Shopify's OWN native cart-drawer re-render (the
  // X-SW-Silent-Cart-Sync header only suppresses OUR OWN listeners, not
  // Shopify's built-in cart-items-component) — with several real items
  // in the cart, ONE user action could cascade into 4-6+ separate
  // native re-renders, which is exactly the flickering that was
  // reported.
  //
  // This blanket re-sync is no longer needed for correctness: _api_price
  // is already set correctly at add-time by every add-to-cart flow in
  // this theme, the Cart Transform Function (sw-price-line-sync) now
  // guarantees the REAL checkout price server-side regardless of any
  // display-property drift, and genuine location-driven price changes
  // are handled by the dedicated sw-pincode-cart-recheck.js script
  // (which only runs on an actual pincode change, not on every cart
  // mutation). free-gift.js still gets fresh gift data because it
  // explicitly calls and awaits window.__swSyncAllCartItemPrices()
  // itself before reading window.__swItemGiftData — that dependency is
  // untouched; only the redundant "also run this on every unrelated
  // mutation" trigger is gone.
  //
  // syncAllCartItemPrices() itself is UNCHANGED and still runs once on
  // initial page load (below) so gift data is populated for a cart the
  // shopper already had when the page loads.

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scheduleSync(200); });
  } else {
    scheduleSync(200);
  }
})();
